import Link from "next/link"

export const createProductTrialPageLink = (
  locale: string | undefined | null,
  button: any,
) => {
  if (!button) {
    return
  }
  // `slug` is the source of truth for this page's URL — no link without one
  // (e.g. an in-progress draft being previewed before an author has set it).
  const productSlug = button?.slug || button?.url?.slug
  if (!productSlug) {
    return
  }
  return {
    url: `/${locale}/products/${productSlug}/trial`,
    text: button?.text
      ? button?.text
      : button?.url?.title || button?.url?.productName
        ? `Start a trial of ${button?.url?.title || button?.url?.productName}`
        : button?.title || button?.productName
          ? `Start a trial of ${button?.title || button?.productName}`
          : `Start a Trial`,
    type: "link",
    external: false,
    publicPage: true,
    link: Link,
  }
}

export const createProductDetailPageLink = (locale: string, button: any) => {
  if (!button) {
    return
  }
  // `slug` is the source of truth for this page's URL — no link without one
  // (e.g. an in-progress draft being previewed before an author has set it).
  const productSlug = button?.slug || button?.url?.slug
  if (!productSlug) {
    return
  }
  return {
    url: `/${locale}/products/${productSlug}/buy`,

    text: button?.text
      ? button?.text
      : button?.url?.url
        ? `Buy ${button?.url?.url}`
        : `Buy Now`,
    type: "link",
    external: false,
    publicPage: true,
    link: Link,
  }
}
